module.exports = __webpack_public_path__ + "static/media/xiaokang.cdb25cf5.png";